import { component } from 'picoapp';
import Modal from 'utils/modal';
import Swiper, {
  SwiperOptions, EffectFade, Navigation, Pagination,
} from 'swiper';

export default component(async (node) => {
  const modal = Modal(node);

  const toggles = document.querySelectorAll('[data-image-toggle]');
  const closeButton = node.querySelector<HTMLButtonElement>('[data-close]');
  const sliderElement = node.querySelector<HTMLElement>('[data-slider]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      modal.toggle();
    });
  });

  closeButton.addEventListener('click', () => {
    modal.close();
  });

  const swiperParams:SwiperOptions = {
    modules: [EffectFade, Pagination, Navigation],
    effect: 'fade',
    loop: true,
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-lightbox--next',
      prevEl: '.swiper-lightbox--prev',
    },
    init: false,
  };

  const swiper = new Swiper(sliderElement, swiperParams);

  swiper.init();
});
